/*! ps-home.js · Ponte Salsa · Home v2 (CRO) · sin dependencias
 *  Módulos: cintillo con progreso de carrito, cuenta regresiva, pestañas, agregar rápido,
 *  pop-up, barra móvil, UGC, aviso.
 *  Se puede cargar varias veces (cada sección lo incluye); solo se inicializa una vez.
 *  Ganchos opcionales (solo para pruebas / vista previa):
 *    window.PS_SCROLL_ROOT   elemento que hace scroll (por defecto: window)
 *    window.PS_OVERLAY_ROOT  dónde montar pop-up, modales y avisos (por defecto: body)
 */
(function () {
  'use strict';
  if (window.PS && window.PS.init) { window.PS.init(); return; }

  var PS = (window.PS = {});
  var DOC = document;
  function $(s, r) { return (r || DOC).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || DOC).querySelectorAll(s)); }
  function store(k, v) {
    try {
      if (v === undefined) return window.localStorage.getItem(k);
      window.localStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function sstore(k, v) {
    try {
      if (v === undefined) return window.sessionStorage.getItem(k);
      window.sessionStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function overlayRoot() { return window.PS_OVERLAY_ROOT || DOC.body; }
  function scrollEl() { return window.PS_SCROLL_ROOT || null; }
  function scrollInfo() {
    var el = scrollEl();
    if (el) return { y: el.scrollTop, h: el.scrollHeight, vh: el.clientHeight };
    var de = DOC.documentElement;
    return { y: window.pageYOffset || de.scrollTop, h: Math.max(de.scrollHeight, DOC.body.scrollHeight), vh: window.innerHeight };
  }
  function onScroll(fn) { (scrollEl() || window).addEventListener('scroll', fn, { passive: true }); }

  /* ---------- formato de dinero (usa la moneda activa de la tienda) ---------- */
  var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'MXN';
  var fmt;
  try { fmt = new Intl.NumberFormat(DOC.documentElement.lang || 'es-MX', { style: 'currency', currency: cur, maximumFractionDigits: 0 }); }
  catch (e) { fmt = { format: function (n) { return '$' + Math.round(n).toLocaleString('es-MX'); } }; }
  function money(cents) { return fmt.format(cents / 100); }
  PS.money = money;

  /* ---------- medición (GA4 / GTM / Clarity) ---------- */
  PS.track = function (name, data) {
    var p = data || {};
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: 'ps_' + name }; for (var k in p) o[k] = p[k];
      window.dataLayer.push(o);
      if (typeof window.clarity === 'function') window.clarity('event', 'ps_' + name);
    } catch (e) {}
  };

  /* ---------- carrito ---------- */
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  PS.cfg = null; /* { free, bonus, pct } en unidades de moneda; lo fija el cintillo o el pop-up */
  PS.cart = {
    data: null,
    _p: null,
    get: function () {
      if (!PS.cart._p) PS.cart._p = PS.cart.refresh();
      return PS.cart._p;
    },
    refresh: function () {
      PS.cart._p = fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { PS.cart.data = c; broadcast(c); return c; })
        .catch(function () { return { total_price: 0, item_count: 0 }; });
      return PS.cart._p;
    },
    add: function (items) {
      return fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) { var e = new Error(j.description || j.message || 'error'); e.api = true; throw e; }
          return j;
        });
      }).then(function () { return PS.cart.refresh(); });
    }
  };
  function broadcast(c) {
    DOC.dispatchEvent(new CustomEvent('ps:cart', { detail: c }));
    $$('.cart-count-bubble span[aria-hidden],[data-cart-count],.js-cart-count,#CartCount,.cart-count').forEach(function (el) {
      el.textContent = c.item_count;
    });
    if (typeof PS.onCartUpdated === 'function') { try { PS.onCartUpdated(c); } catch (e) {} }
  }
  function progress(totalCents, cfg, opts) {
    var c = cfg || PS.cfg; if (!c || !totalCents) return null;
    var t = totalCents / 100, noBonus = opts && opts.noBonus;
    if (c.free && t < c.free) return { k: 'free', text: 'Te faltan ' + fmt.format(c.free - t) + ' para envío gratis', pct: Math.min(100, t / (c.bonus || c.free) * 100) };
    if (noBonus) return { k: 'done', text: c.free ? '¡Tienes envío gratis!' : '', pct: 100 };
    if (c.bonus && t < c.bonus) return { k: 'bonus', text: (c.free ? '¡Envío gratis! ' : '') + 'Te faltan ' + fmt.format(c.bonus - t) + ' para ' + c.pct + '% adicional', pct: Math.min(100, t / c.bonus * 100) };
    if (c.bonus) return { k: 'done', text: '¡Tienes ' + (c.free ? 'envío gratis y ' : '') + c.pct + '% adicional!', pct: 100 };
    return { k: 'done', text: '¡Tienes envío gratis!', pct: 100 };
  }
  PS.progress = progress;

  /* ---------- aviso (toast) ---------- */
  var toastEl, toastT;
  function toast(msg, opts) {
    opts = opts || {};
    if (!toastEl) {
      toastEl = DOC.createElement('div');
      toastEl.className = 'ps-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      overlayRoot().appendChild(toastEl);
    }
    toastEl.classList.toggle('ps-toast--err', !!opts.error);
    var inner = DOC.createElement('div'); inner.className = 'ps-toast__in';
    var row = DOC.createElement('div'); row.className = 'ps-toast__r';
    var s = DOC.createElement('span'); s.textContent = msg; row.appendChild(s);
    if (!opts.error) {
      var a = DOC.createElement('a'); a.href = root + 'cart'; a.textContent = 'Ver carrito'; row.appendChild(a);
    }
    inner.appendChild(row);
    if (opts.extra) { var p = DOC.createElement('div'); p.className = 'ps-toast__p'; p.textContent = opts.extra; inner.appendChild(p); }
    var w = DOC.createElement('div'); w.className = 'ps-toast__w'; w.appendChild(inner);
    toastEl.innerHTML = ''; toastEl.appendChild(w);
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, opts.error ? 4500 : 5500);
  }
  PS.toast = toast;
  function hideToast() { if (toastEl) toastEl.classList.remove('is-on'); }
  function afterAdd(title, cart) {
    var pr = progress(cart.total_price);
    toast(title, { extra: pr ? pr.text : '' });
  }

  /* ---------- A · cintillo ---------- */
  function initAnn() {
    $$('[data-ps-ann]').forEach(function (el) {
      if (el.getAttribute('data-ps-ready')) return; el.setAttribute('data-ps-ready', '1');
      var cfg = { free: +el.getAttribute('data-free') || 0, bonus: +el.getAttribute('data-bonus') || 0, pct: +el.getAttribute('data-pct') || 10 };
      if (!PS.cfg) PS.cfg = cfg;
      if (el.getAttribute('data-progress') !== 'true') return;
      var withBonus = el.getAttribute('data-show-bonus') === 'true';
      function paint(c) {
        var pr = progress(c.total_price, cfg, { noBonus: !withBonus });
        $$('[data-ps-ann-progress]', el).forEach(function (li) {
          if (!pr || !pr.text) { li.hidden = true; return; }
          li.hidden = false; li.textContent = pr.text;
        });
      }
      PS.cart.get().then(paint);
      DOC.addEventListener('ps:cart', function (e) { paint(e.detail); });
    });
  }

  /* ---------- B · cuenta regresiva real ---------- */
  function initCount() {
    $$('[data-ps-count]').forEach(function (el) {
      if (el.getAttribute('data-ps-ready')) return; el.setAttribute('data-ps-ready', '1');
      var end = Date.parse(el.getAttribute('data-ps-count'));
      if (isNaN(end)) { el.hidden = true; return; }
      var nums = $$('[data-u]', el);
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var d = end - Date.now();
        if (d <= 0) { el.hidden = true; clearInterval(iv); return; }
        var s = Math.floor(d / 1000), parts = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
        nums.forEach(function (n) { n.firstChild.nodeValue = pad(parts[n.getAttribute('data-u')]); });
        el.hidden = false;
      }
      var iv = setInterval(tick, 1000); tick();
    });
  }

  /* ---------- F · pestañas ---------- */
  function initTabs() {
    $$('[data-ps-tabs]').forEach(function (el) {
      if (el.getAttribute('data-ps-ready')) return; el.setAttribute('data-ps-ready', '1');
      var tabs = $$('[role=tab]', el), panels = $$('[role=tabpanel]', el);
      function sel(i, focus) {
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', String(i === j)); t.tabIndex = i === j ? 0 : -1; });
        panels.forEach(function (p, j) { p.hidden = i !== j; });
        if (focus) tabs[i].focus();
        PS.track('tab', { label: tabs[i].textContent.trim() });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { sel(i); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, n = tabs.length;
          if (k === 'ArrowRight') { e.preventDefault(); sel((i + 1) % n, true); }
          else if (k === 'ArrowLeft') { e.preventDefault(); sel((i - 1 + n) % n, true); }
          else if (k === 'Home') { e.preventDefault(); sel(0, true); }
          else if (k === 'End') { e.preventDefault(); sel(n - 1, true); }
        });
      });
    });
  }

  /* ---------- E · agregar rápido (delegado) ---------- */
  function closeQA(except) {
    $$('.ps-qa__open[aria-expanded="true"]').forEach(function (b) {
      var w = b.closest('.ps-qa'); if (w === except) return;
      b.setAttribute('aria-expanded', 'false');
      var z = $('.ps-qa__sizes', w); if (z) z.hidden = true;
    });
  }
  function qaAdd(btn) {
    var id = +btn.getAttribute('data-variant'); if (!id) return;
    var wrap = btn.closest('.ps-qa'), card = btn.closest('.ps-card');
    var title = card ? ($('.ps-card__t', card) || {}).textContent : '';
    var openBtn = $('.ps-qa__open', wrap);
    btn.classList.add('is-busy'); btn.disabled = true;
    PS.track('quick_add', { variant: id, title: (title || '').trim() });
    PS.cart.add([{ id: id, quantity: 1 }]).then(function (cart) {
      closeQA();
      if (openBtn) { openBtn.classList.add('is-done'); var o = openBtn.textContent; openBtn.textContent = 'Agregado ✓'; setTimeout(function () { openBtn.classList.remove('is-done'); openBtn.textContent = o; }, 2200); }
      afterAdd('Agregado: ' + (title || 'producto').trim().slice(0, 40), cart);
    }).catch(function (e) {
      toast(e && e.api ? e.message : 'No se pudo agregar. Intenta de nuevo.', { error: true });
    }).then(function () { btn.classList.remove('is-busy'); btn.disabled = false; });
  }
  DOC.addEventListener('click', function (e) {
    var t = e.target;
    var op = t.closest && t.closest('[data-ps-qa-open]');
    if (op) {
      var w = op.closest('.ps-qa'), z = $('.ps-qa__sizes', w), open = op.getAttribute('aria-expanded') === 'true';
      closeQA(w);
      op.setAttribute('aria-expanded', String(!open)); if (z) z.hidden = open;
      return;
    }
    var ad = t.closest && t.closest('[data-ps-qa-add]');
    if (ad) { qaAdd(ad); return; }
    if (!(t.closest && t.closest('.ps-qa'))) closeQA();
  });

  /* ---------- utilidades de superposiciones (pop-up) ---------- */
  var lastFocus = null, openModal = null;
  function lockScroll(on) { if (!window.PS_SCROLL_ROOT) DOC.documentElement.style.overflow = on ? 'hidden' : ''; }
  function trap(e, box) {
    if (e.key !== 'Tab') return;
    var f = $$('a[href],button:not([disabled]),select,input,[tabindex="0"]', box).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && DOC.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && DOC.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  DOC.addEventListener('keydown', function (e) {
    if (openModal) trap(e, openModal);
  });

  /* ---------- N · pop-up de primera compra ---------- */
  function initPopup() {
    var pop = $('[data-ps-popup]'); if (!pop || pop.getAttribute('data-ps-ready')) return;
    pop.setAttribute('data-ps-ready', '1');
    overlayRoot().appendChild(pop);
    var delay = (+pop.getAttribute('data-delay') || 15) * 1000, scrollPct = +pop.getAttribute('data-scroll') || 50;
    var exit = pop.getAttribute('data-exit') === 'true', cool = +pop.getAttribute('data-cool') || 7;
    var showOn = pop.getAttribute('data-show-on'), page = pop.getAttribute('data-page');
    var design = window.Shopify && window.Shopify.designMode;
    var shown = false;
    function open(manual) {
      if (openModal && !manual) return;
      hideToast(); lastFocus = DOC.activeElement; pop.hidden = false; lockScroll(true); PS.overlayOpen = true; openModal = pop; shown = true;
      var f = $('input[type=email]', pop) || $('.ps-pop__x', pop); if (f) f.focus();
      if (!manual) sstore('ps_pop_seen', '1');
      PS.track('popup_view', { manual: !!manual });
    }
    function close(dismissed) {
      pop.hidden = true; if (openModal === pop) openModal = null; lockScroll(false); PS.overlayOpen = false;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      if (dismissed) store('ps_pop_until', String(Date.now() + cool * 864e5));
      PS.track('popup_close', { dismissed: !!dismissed });
    }
    PS.popup = { open: function () { open(true); }, close: function () { close(false); } };
    pop.addEventListener('click', function (e) { if (e.target === pop || e.target.classList.contains('ps-pop__c')) close(true); });
    $$('[data-ps-pop-x]', pop).forEach(function (b) { b.addEventListener('click', function () { close(true); }); });
    var C = $('[data-ps-pop-cta]', pop);
    if (C) C.addEventListener('click', function (e) {
      PS.track('popup_cta');
      if (C.getAttribute('href') === '#' || !C.getAttribute('href')) { e.preventDefault(); close(true); }
    });
    var cb = $('[data-ps-copy]', pop);
    if (cb) cb.addEventListener('click', function () {
      var v = $('[data-ps-pop-code-v]', pop).textContent.trim();
      PS.track('popup_copy');
      try { navigator.clipboard.writeText(v).then(function () { cb.textContent = '¡Copiado!'; }, function () { cb.textContent = v; }); } catch (e) { cb.textContent = v; }
    });
    DOC.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openModal === pop) close(true); });
    var pv = $('[data-ps-pop-preview]'); if (pv) pv.addEventListener('click', function () { open(true); });

    /* ¿se debe mostrar solo? */
    var qs = (window.location.search || '');
    if ($('[data-ps-posted]', pop)) { /* acaba de dejar su correo: muestra el código y no vuelvas a molestar */
      store('ps_pop_until', String(Date.now() + 30 * 864e5));
      PS.track('popup_signup_ok'); open(true); return;
    }
    if (qs.indexOf('ps_popup=1') > -1) { open(true); return; }
    if (qs.indexOf('ps_popup=reset') > -1) { sstore('ps_pop_seen', ''); store('ps_pop_until', ''); }
    if (design) return;
    if (pop.getAttribute('data-enabled') !== 'true') return;
    if (pop.getAttribute('data-skip') === 'true') return; /* ya compró: no es primera compra */
    if (page === 'cart' || page === 'product' || /^customers/.test(page) || page === 'password') return;
    if (showOn === 'home' && page !== 'index') return;
    if (showOn === 'home_collections' && page !== 'index' && page !== 'collection' && page !== 'list-collections') return;
    if (sstore('ps_pop_seen') === '1') return;
    if (+store('ps_pop_until') > Date.now()) return;

    var done = false, t0 = Date.now();
    function go() { if (done || shown) return; done = true; cleanup(); open(false); }
    var t = setTimeout(go, delay);
    function chk() { var s = scrollInfo(); if (s.h - s.vh > 0 && s.y / (s.h - s.vh) * 100 >= scrollPct) go(); }
    function mo(e) { if (e.clientY <= 0 && Date.now() - t0 > 5000) go(); }
    onScroll(chk);
    if (exit && window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches) DOC.addEventListener('mouseout', mo);
    function cleanup() { clearTimeout(t); DOC.removeEventListener('mouseout', mo); }
  }

  /* ---------- O · progreso del carrito (página del carrito) ---------- */
  function initCartBar() {
    $$('[data-ps-cbar]').forEach(function (el) {
      if (el.getAttribute('data-ps-ready')) return; el.setAttribute('data-ps-ready', '1');
      var cfg = { free: +el.getAttribute('data-free') || 0, bonus: +el.getAttribute('data-bonus') || 0, pct: +el.getAttribute('data-pct') || 10 };
      var T = $('[data-ps-cbar-t]', el), bar = $('[data-ps-cbar-bar]', el), fill = bar && $('i', bar), mk = $('[data-ps-cbar-mk]', el);
      var max = cfg.bonus || cfg.free || 1, empty = T ? T.textContent : '';
      if (mk && cfg.free && cfg.bonus) mk.style.left = (cfg.free / cfg.bonus * 100) + '%'; else if (mk) mk.hidden = true;
      function paint(c) {
        var t = (c && c.total_price || 0) / 100, pr = progress(c && c.total_price, cfg);
        if (T) T.textContent = pr ? pr.text : empty;
        var w = Math.min(100, t / max * 100);
        if (fill) fill.style.width = w + '%';
        if (bar) bar.setAttribute('aria-valuenow', String(Math.round(w)));
        $$('[data-ps-cbar-step]', el).forEach(function (li) {
          var need = li.getAttribute('data-ps-cbar-step') === 'free' ? cfg.free : cfg.bonus;
          li.classList.toggle('is-done', !!need && t >= need);
        });
      }
      PS.cart.get().then(paint);
      DOC.addEventListener('ps:cart', function (e) { paint(e.detail); });
    });
  }

  /* ---------- O · barra móvil ---------- */
  function initSticky() {
    var el = $('[data-ps-sticky]'); if (!el || el.getAttribute('data-ps-ready')) return;
    el.setAttribute('data-ps-ready', '1');
    var after = +el.getAttribute('data-after') || 500, page = el.getAttribute('data-page'), showOn = el.getAttribute('data-show-on');
    if (el.getAttribute('data-enabled') !== 'true') return;
    if (page === 'cart' || page === 'product' || /^customers/.test(page)) return;
    if (showOn === 'home' && page !== 'index') return;
    if (showOn === 'home_collections' && page !== 'index' && page !== 'collection') return;
    function chk() { el.classList.toggle('is-on', scrollInfo().y > after && !PS.overlayOpen); }
    onScroll(chk); chk();
    $$('a', el).forEach(function (a) { a.addEventListener('click', function () { PS.track('sticky_click', { label: a.getAttribute('data-label') || '' }); }); });
  }

  /* ---------- J · UGC ---------- */
  function initUgc() {
    $$('[data-ps-clip]').forEach(function (c) {
      if (c.getAttribute('data-ps-ready')) return; c.setAttribute('data-ps-ready', '1');
      var v = $('video', c), b = $('.ps-clip__m', c); if (!v || !b) return;
      b.addEventListener('click', function () {
        if (v.paused) {
          $$('[data-ps-clip] video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('.ps-clip').classList.remove('is-on'); } });
          v.muted = true; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
          c.classList.add('is-on'); PS.track('ugc_play', { handle: c.getAttribute('data-handle') || '' });
        } else { v.pause(); c.classList.remove('is-on'); }
      });
      if (!v.getAttribute('data-sources-set')) {
        v.setAttribute('data-sources-set', '1'); v.preload = 'none';
      }
    });
  }

  /* ---------- medición de clics en CTAs ---------- */
  DOC.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-ps-track]');
    if (a) PS.track('cta', { label: a.getAttribute('data-ps-track') });
  });

  /* ---------- arranque ---------- */
  PS.init = function () {
    initAnn(); initCount(); initTabs(); initPopup(); initSticky(); initUgc(); initCartBar();
  };
  if (DOC.readyState === 'loading') DOC.addEventListener('DOMContentLoaded', PS.init); else PS.init();
  DOC.addEventListener('shopify:section:load', PS.init); /* editor de temas */
})();
